import React from 'react'
import { Link, useMatch, useResolvedPath } from "react-router-dom"

export default function Navbar() {
  return (
        <nav className="nav text-sm mb-12 flex justify-between">
          <a href='/' className="site-title">RONNEE SWENTON</a>
          <ul className="flex items-center space-x-4">
            <CustomLink to="/portfolio">Portfolio</CustomLink>
            <CustomLink to="/about">About</CustomLink>
          </ul>
        </nav>
  )
}

function CustomLink({ to, children, ...props }) {
  const resolvedPath = useResolvedPath(to)
  const isActive = useMatch({ path: resolvedPath.pathname, end: true })

  return (
    <li className={isActive ? "active" : ""}>
      <Link to={to} {...props}>
        {children}
      </Link>
    </li>
  )
}